import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './Unknown.scss';
export var Unknown = function (_a) {
    var width = _a.width, height = _a.height;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'], style: { width: width, height: height } }, t('deviationview.unknown')));
};
Unknown.displayName = 'Unknown';
export default Unknown;
//# sourceMappingURL=Unknown.js.map